import Vue from 'vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default (WordCloudView) => Vue.component('WordCloudController', {
  computed: {
    ...mapGetters([
      'isAllowedTextRemoval',
      'wordsToDisplay',
    ]),
    ...mapState({
      slideOptions: (state) => state.slideActive.SlideOptions,
      presentation: (state) => state.presentation,
      isGroupWordCloudWords: (state) => state.isGroupWordCloudWords,
      slideActive: (state) => state.slideActive,
    }),
  },
  mounted() {
    if (this.slideActive) {
      this.initWordCloudAction(this.slideActive)
      this.listenWordCloudRealtimeUpdateAction(this.slideActive)
    }
    // when receive the AI grouped wordcloud -> re init the word cloud
    EventBus.$on('word-cloud-smart-grouping: pre-build', () => {
      this.initWordCloudAction(this.slideActive)
    })
    // switch back n forth between original & AI groupped word cloud.
    EventBus.$on('toggleWordCloud', () => {
      this.initWordCloudAction(this.slideActive)
    })
  },
  beforeDestroy() {
    EventBus.$off('word-cloud-smart-grouping: pre-build')
    EventBus.$off('toggleWordCloud')
  },

  methods: {
    ...mapActions([
      'initWordCloudAction',
      'listenWordCloudRealtimeUpdateAction',
      'removeWordInCloudAction',
    ]),
    getFillColor(word) {
      return word.color
    },
    getWordRotation(word) {
      if (word.isMax || word.text.length > 18 || word.size > 50) {
        return 0
      }

      return ~~(Math.random() * 2) * 270
    },

    onWordClick(word) {
      this.removeWordInCloudAction(word)
    },

  },

  render(createElement) {
    return createElement(WordCloudView, {
      props: {
        id: this.slideActive.id,
        width: 1180,
        height: 480,
        padding: '4',
        font: '\'Nunito\', sans-serif',
        words: this.wordsToDisplay,
        rotate: this.getWordRotation,
        fill: this.getFillColor,
        onWordClick: this.onWordClick,
        isAllowedTextRemoval: this.isAllowedTextRemoval,
      },
    })
  },
})
